import { View } from 'react-native';

import Phone from '../components/Phone';

export const PhoneScreen = () => <View style={{ flex: 1 }}><Phone /></View>;
